import React from 'react';

import styles from './investmentPreferencesStyles';

const InvestmentPreferences = ({ allocatorProfile }) => {
  const {
    sectorPreferences,
    geographyPreferences,
    assetClassPreferences,
    fundTypePreferences,
    fundStrategyPreferences,
    aumRangePreferences
  } = allocatorProfile;
  const items = [
    { label: 'Sector Expertise', value: sectorPreferences.join(', ') },
    { label: 'Geographic Expertise', value: geographyPreferences.join(', ') },
    { label: 'Asset Class Expertise', value: assetClassPreferences.join(', ') },
    { label: 'Fund Type', value: fundTypePreferences.join(', ') },
    { label: 'Strategic Expertise', value: fundStrategyPreferences.join(', ') },
    { label: 'AUM Range', value: aumRangePreferences.join(', ') }
  ];
  return (
    <div>
      <ul className={styles.investmentPreferencesList}>
        {items.map((item, idx) => (
          <li key={idx}>
            <h4>{item.label}</h4>
            <span>{item.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default InvestmentPreferences;
